/*
 * @FilePath: operateConfig.js
 * @Author: Aron
 * @Date: 2023-07-21 11:27:05
 * @LastEditors: hushun hushun@songshuai.com
 * @LastEditTime: 2025-05-27 17:11:13
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
export default [
  {
    path: "purchasing",
    name: "purchasing",
    meta: {
      title: "purchaseOrders"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/Purchasing")
  },
  {
    path: "SecondmentGoods",
    name: "SecondmentGoods",
    meta: {
      title: "transferGoodsManagement"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/SecondmentGoods")
  },
  {
    path: "Creditorders",
    name: "Creditorders",
    meta: {
      title: "creditOrders"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/Creditorders")
  },
  {
    path: "DoubleOrder",
    name: "DoubleOrder",
    meta: {
      title: "doubleOrders"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/DoubleOrder")
  },
  {
    path: "DoubleOrderCreation",
    name: "DoubleOrderCreation",
    meta: {
      title: "createDoubleOrder"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/DoubleOrderCreation"
      )
  },
  {
    path: "HeadOfficeShipment",
    name: "HeadOfficeShipment",
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/HeadOfficeShipment/HeadOfficeShipment"
      ),
    meta: {
      title: "headOfficeShipment"
    }
  },
  {
    path: "AreaConsignment",
    name: "AreaConsignment",
    meta: {
      title: "regionalShipmentRecords"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/AreaConsignment/index"
      )
  },
  {
    path: "AreaJdSend",
    name: "AreaJdSend",
    meta: {
      title: "regionalJdWarehouseShipment"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/AreaJdSend/index"
      )
  },
  {
    path: "saleConsignmentDetailNew",
    name: "saleConsignmentDetailNew",
    meta: {
        title: "cloudWarehouseShipmentDetails"
    },
    component: () =>
        import("@/views/Home/OperationCenter/DistrictAgentManagement/AreaJdSend/saleConsignmentDetailNew")
  },
  {
    path: "JdSendParamConfig",
    name: "JdSendParamConfig",
    meta: {
      title: "京东仓发货参数配置"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/JdSendParamConfig/index"
      )
  },
  // 发货管理——厂商发货管理
  {
    path: "Manufacturer",
    name: "Manufacturer",
    meta: {
      title: "厂商发货管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/Manufacturer/index"
      )
  },
  // 发货管理——厂商发货管理——导出信息（与销售中心 ImportDetail/:batchNo 仅 name 区分）
  {
    path: "ImportDetail",
    name: "ManufacturerImportDetail",
    meta: {
      title: "导出信息"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/Manufacturer/ImportDetail"
      )
  },
  // 发货管理——厂商设备管理
  {
    path: "DeviceManagement",
    name: "DeviceManagement",
    meta: {
      title: "厂商设备管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/DeviceManagement/index"
      )
  },
  {
    path: "SubscriptionManagement",
    name: "SubscriptionManagement",
    meta: {
      title: "订阅卡管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SubscriptionCardManagement/SubscriptionCard/index"
      )
  },
  {
    path: "PurchaseCreation",
    name: "PurchaseCreation",
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/PurchaseCreation"
      ),
    meta: {
      title: "创建采购订单"
    }
  },
  {
    path: "PurchaseCreation2",
    name: "PurchaseCreation2",
    component: () =>
      import(
        "@/views/Home/ServiceCenter/MachineAccountManagement/SubSubscriptionCard/PurchaseCreation"
      ),
    meta: {
      title: "创建采购订单"
    }
  },
  {
    path: "SecondmentDetails",
    name: "SecondmentDetails",
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/SecondmentDetails"
      ),
    meta: {
      title: "transferGoodsManagement"
    }
  },
  {
    path: "studyMachine",
    name: "studyMachine",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/studyMachine"),
    meta: {
      title: "studyMachineManagement"
    }
  },
  {
    path: "TakeDelivery",
    name: "TakeDelivery",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/TakeDelivery"),
    meta: {
      title: "takeDelivery"
    }
  },
  {
    path: "DeliveryCreation",
    name: "DeliveryCreation",
    component: () =>
      import(
        "@/views/Home/OperationCenter/EquipmentManagement/page/DeliveryCreation"
      ),
    meta: {
      title: "newLading"
    }
  },
  {
    path: "DeliveryDetail",
    name: "DeliveryDetail",
    component: () =>
      import(
        "@/views/Home/OperationCenter/EquipmentManagement/page/DeliveryDetail"
      ),
    meta: {
      title: "ladingDetail"
    }
  },
  {
    path: "barterManage",
    name: "barterManage",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/barterManage"),
    meta: {
      title: "barterManagement"
    }
  },
  {
    path: "barterManage/information",
    name: "barterManage/information",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/barterManage/information"),
    meta: {
      title: "barterManagement"
    }
  },
  // {
  //   path: "PrototypeManagement",
  //   name: "PrototypeManagement",
  //   component: () =>
  //     import(
  //       "@/views/Home/OperationCenter/EquipmentManagement/PrototypeManagement"
  //     ),
  //   meta: {
  //     title: "样机管理"
  //   }
  // },
  {
    path: "ChildrenDevice",
    name: "ChildrenDevice",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/ChildrenDevice"),
    meta: {
      title: "teacherChildrenDevice"
    }
  },
  {
    path: "ChildrenDeviceDetails",
    name: "ChildrenDeviceDetails",
    component: () =>
      import(
        "@/views/Home/OperationCenter/EquipmentManagement/page/ChildrenDeviceDetails"
      ),
    meta: {
      title: "childrenDeviceDetail"
    }
  },
  {
    path: "AdvertiseMessage",
    name: "AdvertiseMessage",
    component: () => import("@/views/Home/showCard/AdvertiseMessage"),
    meta: {
      title: "公告中心"
    }
  },
  {
    path: "AdvertiseMessageDetail",
    name: "AdvertiseMessageDetail",
    component: () => import("@/views/Home/showCard/AdvertiseMessageDetail"),
    meta: {
      title: "公告中心"
    }
  },
  {
    path: "CreditordersCreation",
    name: "CreditordersCreation",
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/CreditordersCreation"
      ),
    meta: {
      title: "验货订单"
    }
  },
  // 金账户管理
  {
    path: "AgencyHierarchyMaintenance",
    name: "AgencyHierarchyMaintenance",
    component: () =>
      import(
        "@/views/Home/OperationCenter/SubscriptionCardManagement/AgencyHierarchyMaintenance"
      ),
    meta: {
      title: "goldAccountManagement"
    }
  },
  // 小程序消息-发消息
  {
    path: "SendMsg",
    name: "SendMsg",
    component: () => import("@/views/Home/operateManage/BackConfig/SendMsg"),
    meta: {
      title: "发消息"
    }
  },
  // 小程序消息-历史消息
  {
    path: "MsgList",
    name: "MsgList",
    component: () => import("@/views/Home/operateManage/BackConfig/MsgList"),
    meta: {
      title: "历史消息"
    }
  },
  {
    path: "AutomaticOrderConfiguration",
    name: "AutomaticOrderConfiguration",
    component: () => import("@/views/Home/OperationCenter/AutomaticOrderConfiguration/index"),
    meta: {
      title: "自动下单配置"
    }
  },
  // 升降级详情
  {
    path: "UpgradeDetails",
    name: "UpgradeDetails",
    component: () => import("@/views/Home/showCard/UpgradeDetails"),
    meta: {
      title: "升降级详情"
    }
  }
];
